/* Shree Book Centre — shared bulk add-to-cart engine.
 * Used by the Series page (sbc-series.js) and the product-page "Add All Available"
 * (Compact Series). Centralises the resilient add, flying-books animation, cart
 * drawer opening, cart:update dispatch, and a lightweight toast — so the logic
 * lives in one place. Every title stays an individual line item.
 *
 * API (window.SBCBulkAdd):
 *   addItems(ids, opts) -> Promise<{ added:Number, failed:[ids] }>
 *       opts.openDrawer  (default true)  — open the cart drawer on success
 *   fly(elements)        — staggered flying-books from the given <img> elements
 *   toast(msg, isWarn)   — transient confirmation message
 */
(function () {
  'use strict';
  if (window.SBCBulkAdd) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  function sectionIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('cart-items-component'),
      function (el) { return el.dataset.sectionId; }
    ).filter(Boolean).join(',');
  }

  function dispatchCartUpdate(res, qty) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: res, data: { source: 'product-form-component', itemCount: qty, sections: res && res.sections } }
    }));
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) { /* noop */ } }
  }

  function post(body) {
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { e.__http = r.status; throw e; }); }
      return r.json();
    });
  }

  /* Add many variant IDs. One atomic /cart/add.js call; if it fails (e.g. a title
     sold out mid-flight, which is all-or-nothing), fall back to adding each one so
     the rest still land and we can report which ones failed. */
  function addItems(ids, opts) {
    opts = opts || {};
    var open = opts.openDrawer !== false;
    if (!ids || !ids.length) return Promise.resolve({ added: 0, failed: [] });

    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    return post({ items: items, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (res) {
        dispatchCartUpdate(res, ids.length);
        if (open) openDrawer();
        return { added: ids.length, failed: [] };
      })
      .catch(function () { return sequential(ids, open); });
  }

  function sequential(ids, open) {
    var added = 0, failed = [], lastRes = null;
    var chain = Promise.resolve();
    ids.forEach(function (id) {
      chain = chain.then(function () {
        return post({ id: parseInt(id, 10), quantity: 1, sections: sectionIds(), sections_url: window.location.pathname })
          .then(function (res) { added++; lastRes = res; })
          .catch(function () { failed.push(id); });
      });
    });
    return chain.then(function () {
      if (lastRes) { dispatchCartUpdate(lastRes, added); if (open) openDrawer(); }
      return { added: added, failed: failed };
    });
  }

  /* Flying-books — reuses Horizon's <fly-to-cart> element. */
  function ensureFly() {
    if (customElements.get('fly-to-cart')) return;
    try { import('@theme/fly-to-cart').catch(function () {}); } catch (e) { /* no importmap */ }
  }
  function flyOne(src, url) {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (reduce || !icon || !src || !url || !customElements.get('fly-to-cart')) return;
    var el = document.createElement('fly-to-cart');
    el.classList.add('fly-to-cart--quick');
    el.style.setProperty('background-image', 'url(' + url + ')');
    el.style.setProperty('--start-opacity', '0');
    el.source = src;
    el.destination = icon;
    document.body.appendChild(el);
  }
  function fly(elements) {
    if (!elements) return;
    var cap = Math.min(elements.length, 10);
    for (var i = 0; i < cap; i++) {
      (function (img, idx) {
        setTimeout(function () { if (img) flyOne(img, img.currentSrc || img.getAttribute('src')); }, idx * 85);
      })(elements[i], i);
    }
  }

  /* Lightweight toast (self-contained styles). */
  var toastTimer;
  function toast(msg, isWarn) {
    var t = document.getElementById('sbc-bulkadd-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sbc-bulkadd-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translate(-50%,180%);z-index:9999;' +
        "color:#fff;font-family:'Outfit',system-ui,sans-serif;font-weight:700;font-size:14px;" +
        'padding:13px 20px;border-radius:100px;box-shadow:0 18px 40px -12px rgba(20,16,30,.45);' +
        'max-width:90vw;text-align:center;' +
        (reduce ? '' : 'transition:transform .32s cubic-bezier(.22,1,.36,1);');
      document.body.appendChild(t);
    }
    t.style.background = isWarn ? '#C8960D' : '#2E6D5B';
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.transform = 'translate(-50%,0)'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.transform = 'translate(-50%,180%)'; }, 3200);
  }

  window.SBCBulkAdd = { addItems: addItems, fly: fly, toast: toast, openDrawer: openDrawer, ensureFly: ensureFly };
  ensureFly();
})();
